import { render, staticRenderFns } from "./NoticeTip.vue?vue&type=template&id=5224817c&scoped=true"
import script from "./NoticeTip.vue?vue&type=script&lang=js"
export * from "./NoticeTip.vue?vue&type=script&lang=js"
import style0 from "./NoticeTip.vue?vue&type=style&index=0&id=5224817c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5224817c",
  null
  
)

export default component.exports